import { useState } from 'react';
import { Badge } from '@/components/Badge';
import { Button } from '@/components/Button';
import { CategorySelector } from './CategorySelector';
import type { FinancialCategoryItem, UnmappedRow } from '@/types/schemas';
import { v } from '@/theme/tokens';

interface CategoryMappingRowProps {
  row: UnmappedRow;
  unitName?: string;
  categories: FinancialCategoryItem[];
  canMap: boolean;
  saving: boolean;
  justMapped: boolean;
  onSave: (rawLabel: string, categoryId: string) => void;
}

export function CategoryMappingRow({
  row,
  unitName,
  categories,
  canMap,
  saving,
  justMapped,
  onSave,
}: CategoryMappingRowProps) {
  const [selected, setSelected] = useState<string | null>(null);
  const labelId = `map-label-${row.id}`;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 12px',
        border: `1px solid ${justMapped ? v('positive') : v('line')}`,
        borderRadius: 10,
        marginBottom: 8,
        flexWrap: 'wrap',
        background: justMapped ? v('positive-soft') : 'transparent',
      }}
    >
      <div style={{ flex: '1 1 200px', minWidth: 0 }}>
        <div id={labelId} style={{ fontWeight: 600, fontSize: 13.5 }}>{row.raw_label}</div>
        <div style={{ fontSize: 12, color: v('ink-muted'), marginTop: 2 }}>
          Лист «{row.sheet_name}»{unitName ? ` → ${unitName}` : ''} · строка {row.row_index}
          {' · '}
          {row.suggested_category_id === null ? 'предложение: не определено' : ''}
        </div>
      </div>

      {justMapped ? (
        <Badge tone="positive">✓ Сопоставлено</Badge>
      ) : (
        <>
          <CategorySelector
            categories={categories}
            value={selected}
            onSelect={setSelected}
            disabled={!canMap || saving}
            labelledBy={labelId}
          />
          <Button
            variant="primary"
            disabled={!canMap || !selected || saving}
            onClick={() => selected && onSave(row.raw_label, selected)}
          >
            {saving ? 'Сохранение…' : 'Сопоставить'}
          </Button>
          <Badge tone="warning">Нужно сопоставление</Badge>
        </>
      )}
    </div>
  );
}
